<template>
  <nav id="leftNav">
    <h3>课程导航</h3>
    <ul class="navList">
      <div class="mask" v-show="topNav.length === 0">读取中 请稍候...</div>
      <li
        v-for="(top, topIndex) in topNav"
        :key="topIndex"
        @mouseenter="handleMouseEnter(topIndex)"
        @mouseleave="handleMouseLeave"
      >
        <a
          :href="getTopUrl(top.Url, soukecityId, top.CategoryCode)"
        >{{ top.Name }}</a>
        <transition name="fade" v-if="secNav !== ''">
          <div class="secNav" v-show="secNav[topIndex] && topIndex === currentIndex">
            <dl v-for="(sec, secIndex) in secNav[topIndex]" :key="secIndex">
              <dt>
                <a :href="getSecUrl(sec.Url, sec.CategoryCode, sec.PropertyCondition)">
                  {{ sec.Name }}
                </a>
              </dt>
              <dd v-for="(third, thirdIndex) in thirdNav[topIndex][secIndex]" :key="thirdIndex">
                <a
                  :key="third.Code"
                  :href="getThirdUrl(third.Url, third.CategoryCode, third.PropertyCondition)"
                >{{ third.Name }}</a>
                <i v-show="thirdIndex !== thirdNav[topIndex][secIndex].length - 1">|</i>
              </dd>
            </dl>
          </div>
        </transition>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Leftnav',
  data () {
    return {
      currentIndex: -1
    }
  },
  props: ['topNav', 'secNav', 'thirdNav'],
  computed: {
    getTopUrl () {
      return function (url, soukecityId, CategoryCode) {
        if (url) {
          return url
        } else {
          return `http://souke.xdf.cn/Category/${soukecityId}-${CategoryCode}-0-0.html?v=5`
        }
      }
    },
    getSecUrl () {
      return function (url, CategoryCode, PropertyCondition) {
        if (url) {
          return url
        } else {
          if (PropertyCondition) {
            return `http://souke.xdf.cn/Category/${this.soukecityId}-${CategoryCode}-${PropertyCondition}-0.html?v=5`
          } else {
            return `http://souke.xdf.cn/Category/${this.soukecityId}-${CategoryCode}-0-0.html?v=5`
          }
        }
      }
    },
    getThirdUrl () {
      return function (url, CategoryCode, PropertyCondition) {
        return url === '' ? `http://souke.xdf.cn/Category/${this.soukecityId}-${CategoryCode}-${PropertyCondition}-0.html?v=5` : url
      }
    },
    ...mapState(['soukecityId', 'cityName'])
  },
  methods: {
    handleMouseEnter (index) {
      this.currentIndex = index
    },
    handleMouseLeave () {
      this.currentIndex = -1
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@keyframes loading
  0%,100%
    background-color: rgba(0, 0, 0, .5)
  25%
    background-color: rgba(0, 0, 0, .3)
#leftNav
  width: 175px
  color: $fontcolor
  position: $rel
  float: $fl
  margin-right: 10px
  h3
    background: $mainNavTitleColor
    height: 40px
    font-size: 16px
    line-height: 40px
    position: $rel
    padding-left: 20px
  .navList
    background: $mainNavBodyColor
    padding: 6px 0 12px
    height: 324px
    border-left: 1px solid $mainNavBodyColor
    .mask
      position: absolute
      top: 40px
      bottom: 0
      left: 0
      right: 0
      text-align: center
      background-color: rgba(0, 0, 0, .3)
      background: url(http://file.xdf.cn/neworiental/images/loading.gif) no-repeat center 40%
      background-size: 10%
      animation: loading 2s infinite
      -webkit-animation: loading 2s infinite
      color: #fff
      line-height: 342px
    li
      font-size: 12px
      height: 32px
      line-height: 32px
      padding: 2px 0 2px 20px
      cursor: pointer
      &:hover
        background: #fff
        padding-left: 27px
        transition: padding-left .3s
      &:hover > a
          color: $themeColor
      & > a
        color: #fff
  .secNav
    position: $abs
    min-height: 378px
    top: 40px
    left: 175px
    background: $fontcolor
    width: 590px
    padding: 10px
    border: 1px solid $bdcolor
    border-left: none
    z-index: 1
    dl
      overflow: hidden
      margin-bottom: 10px
      min-height: 46px
      dt
        line-height: 16px
        a
          color: $themeColor
      dd
        float: $fl
        line-height: 0
        a
          line-height: 20px
          padding: 5px 0
          font-size: 12px
          color: #999
          &:hover
            color: $themeColor
        i
          color: #ccc
          margin: 0 9px
</style>



// WEBPACK FOOTER //
// src/pages/home/components/swiper/components/left-part/Leftnav.vue